import React from 'react';
import { func } from 'prop-types';
import deleteHoverIcon from '../../../images/Autocode/deleteHoverIcon.svg';
import { useSelector } from '../../common/react-redux-hooks';

const PreviewHeader = ({ removeAllTargets }) => {
  const { deBuildTargets } = useSelector(
    state => ({
    deBuildTargets: state.deBuild.deBuildTargets,
  }));

  return (
    <div className="de--build--preview--header">
      <div className="de--build--preview--header-row">
        <div className="de--build--preview-target">Targets</div>
        <div className="de--build--preview-sample">Sample</div>
        <div className="de--build--preview-weighted">Wghtd(000)</div>
        <div className="de--build--preview-delete">
          <button type="button" onClick={removeAllTargets} disabled={!deBuildTargets || deBuildTargets.length === 0}>
            <img src={deleteHoverIcon} alt="delete" />
          </button>
        </div>
      </div>
    </div>
  );
};
PreviewHeader.propTypes = {
  removeAllTargets: func,
}
export default PreviewHeader;
